import React, { useEffect, useState } from "react";
import axios from "axios";
import CONFIG from "../config";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";
import { FaUser, FaPhone, FaUserShield } from "react-icons/fa";
import { usePatient } from "../context/PatientContext";
import styles from '../Styles/navbar.module.css';  
import { Link } from 'react-router-dom';

const MyProfileInfo = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseURL = CONFIG.BASE_URL;
   const { doctorInfo, setDoctorInfo } = usePatient(); 

  // Fetch userId from localStorage (or replace with actual auth state)
  //const userId = localStorage.getItem("userId"); 
const userId = doctorInfo.MANDALI_ID;
const token = localStorage.getItem("authToken");

  useEffect(() => {
    if (!userId) {
      setError("User ID not found. Please log in.");
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("authToken");
    axios.get(`${baseURL}/mandali/profile?userId=${userId}`,{
      headers: {
        Authorization: `Bearer ${token}`, // ✅ This is required
        doctorId: doctorInfo.MANDALI_ID,       // 🧑‍⚕️ Custom context
        clinicId: doctorInfo.CLINIC_ID,
        roleId: doctorInfo.MANDALI_ROLE
      },
    })
    .then((res) => {
        setProfile(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load profile.");
        setLoading(false);
      });
  }, [userId]);
  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <p className="text-danger">{error}</p>
      </div>
    );
  }
  

  if (!profile) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card className="shadow-lg p-4" style={{ width: "400px", borderRadius: "15px" }}>
        <Card.Body className="text-center">
          <h2 className="mb-3">My Profile</h2>
          <hr />
          <Row className="mb-3">
            <Col xs={3}>
              <FaUser size={24} className="text-primary" />
            </Col>
            <Col xs={9} className="text-left">
              <h5>{profile.MANDALI_FULL_NAME}</h5>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3}>
              <FaPhone size={24} className="text-success" />
            </Col>
            <Col xs={9} className="text-left">
              <h5>{profile.MANDALI_MOB_NO}</h5>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col xs={3}>
              <FaUserShield size={24} className="text-warning" />
            </Col>
            <Col xs={9} className="text-left">
              <h5>{profile.MANDALI_ROLE === 1 ? "Admin" : "Doctor"}</h5>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <div className={styles.navLinks}>
                      <Link 
                        to={`/edit-doctor/${userId}`} 
//                        className={location.pathname === "/patientlist" || location.pathname === "/patient/*" ? styles.active : ""}
                      >
                        Update My Profile
                      </Link>

      </div>
    </Container>
  );
};
export default MyProfileInfo;
